export default __webpack_public_path__ + "static/media/login_loading.2cb156c4.gif";